import registerForRails from 'js/utils/registerForRails';
import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';

import ResearchInterestDirectorySearch from 'js/research_interest_directory/ResearchInterestDirectorySearch';

setUpModernPage();
registerForRails({ ResearchInterestDirectorySearch });
